import React from 'react';
import './Partners.css';
import { useLanguage } from '../../../../context/LanguageContext';
import translations from '../../../../translations';

// Partner logos
import Grohe from '../../../../assets/Grohe.webp';
import Tahweel from '../../../../assets/tahweel.webp';
import Yamama from '../../../../assets/yamama.webp';
import Jotun from '../../../../assets/jotun.svg';
import CeramicHome from '../../../../assets/ceramichome.webp';
import AnfalDalton from '../../../../assets/anfaldalton.webp';
import Alfnar from '../../../../assets/Alfnar.webp';
import AirExperts from '../../../../assets/airexperts.webp';
import Madagypsum from '../../../../assets/Madagypsum.webp';
import Keybab from '../../../../assets/keybab.webp';
import Jeresy from '../../../../assets/jeresy.webp';
import SBTC from '../../../../assets/sbtc.webp';
import BuildStation from '../../../../assets/build station.webp';
import Alasaseyah from '../../../../assets/Alasaseyah.webp';
import Mashkati from '../../../../assets/mashkati.webp';
import Usami from '../../../../assets/usami.webp';

const partners = [
    { name: 'Grohe', logo: Grohe },
    { name: 'Tahweel', logo: Tahweel },
    { name: 'Yamama', logo: Yamama },
    { name: 'Jotun', logo: Jotun },
    { name: 'Ceramic Home', logo: CeramicHome },
    { name: 'Anfal Dalton', logo: AnfalDalton },
    { name: 'Al Fnar', logo: Alfnar },
    { name: 'Air Experts', logo: AirExperts },
    { name: 'Madagypsum', logo: Madagypsum },
    { name: 'Keybab', logo: Keybab },
    { name: 'Jeresy', logo: Jeresy },
    { name: 'SBTC', logo: SBTC },
    { name: 'Build Station', logo: BuildStation },
    { name: 'Alasaseyah', logo: Alasaseyah },
    { name: 'Mashkati', logo: Mashkati },
    { name: 'Usami', logo: Usami },
];

const Partners = () => {
    const { language, direction } = useLanguage();
    const t = translations[language];
    const isRTL = direction === 'rtl';

    // Duplicate the list so the animation loops seamlessly
    const doubledPartners = [...partners, ...partners];

    return (
        <section id="partners" className={`partners-section ${isRTL ? 'rtl' : ''}`}>
            <div className="partners-header">
                <h2 className="partners-title">{t.partnersTitle}</h2>
                <div className="partners-divider"></div>
            </div>

            <div className="partners-carousel">
                <div className="partners-track">
                    {doubledPartners.map((partner, index) => (
                        <div className="partner-logo-wrapper" key={`${partner.name}-${index}`}>
                            <img src={partner.logo} alt={partner.name} loading="lazy" />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Partners;
